import { useState } from 'react';
import './InputFormForWorkMistake.scss'
import { closeInputFormForWorkMistake, setMistakesOptionQuiz } from '../quizSlice';

const InputFormForWorkMistake = (props) => {
     const [mistakesQuiz, setMistakesQuiz] = useState(props.mistakesOptionQuiz);


   const {dispatch} = props;

    // CHECK IF QUIZ IN FINISHED QUIZES 
    const checkIfQuizInFinishedQuizes = (data, id) => {
        console.log(id);
            const result = data.findIndex(item =>item.quiz_id === id);
            console.log(result);
            return result;
    }
    const resultCheckIfQuizInFinishedQuizes = checkIfQuizInFinishedQuizes(props.finishedQuizes, props.quizRedux.quizId);
    console.log(resultCheckIfQuizInFinishedQuizes);

    //CLOSE INPUT FORM VIEW
    const onClickEnd = () => {
        dispatch(closeInputFormForWorkMistake());
    }

        // HANDLE SET MISTAKE OPTIONS
    const onHandleSetOnlyMistakeQuestionOption = () => {

            setMistakesQuiz(!mistakesQuiz); 

    };
    // CLICK SAVE
    const onSave = () => {

            
            dispatch(setMistakesOptionQuiz(mistakesQuiz));

            dispatch(closeInputFormForWorkMistake(mistakesQuiz)); 
    };


        return (
            <div className='InputFormForWorkMistake'>
                <div className='exit-block'>
                    <button className="exit" onClick={onClickEnd}></button>
                </div>
                <div className="content-block">
                    <div className="container-column">

                        <p> У вас неправильных ответов -  <span>{resultCheckIfQuizInFinishedQuizes  === -1 ? "0" : props.quizRedux.dataQuizForMistakes.length}</span> из <span>{props.quizRedux.dataQuiz.length} </span></p>
                        <div className="container-row">
                            
                            <input  className="check-box" type="checkbox" defaultChecked = {mistakesQuiz}
                                onChange={onHandleSetOnlyMistakeQuestionOption} disabled={props.quizRedux.dataQuizForMistakes.length ===0 ? true : false}
                            ></input>
                            
                            <p>включить в тест вопросы только с неправильными ответами(режим тренировки) </p>
                        </div> 
                    </div>
                    <button   onClick={onSave} disabled={props.quizRedux.dataQuizForMistakes.length ===0 ? true : false}>Сохранить</button>
                </div>
            </div>
        )
  
    

};
export default InputFormForWorkMistake;